// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "v0.1.8-1-gf312f6d",
    "hash": "gf312f6d",
    "distance": 1,
    "tag": "v0.1.8",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.1.8",
        "major": 0,
        "minor": 1,
        "patch": 8,
        "prerelease": [],
        "build": [],
        "version": "0.1.8"
    },
    "suffix": "1-gf312f6d",
    "semverString": "0.1.8+1.gf312f6d",
    "version": "0.1.8",
    "versionDateTime": "2026-10-22T12:13:53.723Z"
};
